export class User {
  id: number;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  isStaff: boolean;
}

export class UserSessionData {
  currentUser: any = {}
  roleTypeId: number;
}

export class UserRegistration {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  applicationUsers: any[];
  roleCode: string;
  hasMultipleRoles: boolean;
  roles: any = [];
  parentUserId?: number;
  userId: number;
}

export class UserUpdate extends UserRegistration {
  id: number;
  applicationType: string
}

export class ClientInfoForUserAdd {
  id: number;
  clientId: number;
  userId: number;
  clientName: string;
  roles: number[];
  adminRoleId: number;
  viewReferrals: boolean;
  disableReferral: boolean;

  dropdownDisplay: string;

  constructor() {
    this.disableReferral = true;
  }
}

export class UserFeature {
  userFeatureId: number;
  userId: number;
  feature: string;
  enabled: boolean;

  constructor() {}
}

export class CrmUserAccount {
  id: number;
  firstName: string;
  surName: string;
  email: string;
  tutorMobile: string;
  userFullName: string;
  userRelationshipId: number;
  clientId: number;

  constructor() {}
}